import { render } from "./GainsLossesDiscounts.vue?vue&type=template&id=2081d3fe&scoped=true"
import script from "./GainsLossesDiscounts.vue?vue&type=script&lang=js"
export * from "./GainsLossesDiscounts.vue?vue&type=script&lang=js"

import "./GainsLossesDiscounts.vue?vue&type=style&index=0&id=2081d3fe&lang=scss&scoped=true"

import exportComponent from "/Users/patrykslak/Documents/projekty/lauron-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2081d3fe"]])

export default __exports__